import _defineProperty from "/builds/speachme/speachmeDesktop/speach-front/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
import "core-js/modules/es.json.stringify.js";
import { __decorate } from "tslib";
import { Component, Prop, Vue } from "vue-facing-decorator";
import QuizHtmlEditor from "@/components/quiz/QuizHtmlEditor.vue";
import WElmessage from "@/components/wrappers/w-elmessage.vue";
import axios from "axios";
import { Events } from "@/events/events";
import AxiosUtils from "@/util/axiosUtils";
let QuizQuestionComplementaryInfoEditor = class QuizQuestionComplementaryInfoEditor extends Vue {
  constructor(...args) {
    super(...args);
    _defineProperty(this, "questionId", void 0);
    _defineProperty(this, "complementaryInfo", void 0);
    _defineProperty(this, "realtimeComplementaryInfo", '');
  }
  mounted() {
    this.realtimeComplementaryInfo = this.complementaryInfo;
  }
  get editorId() {
    return 'question-complementary-info-text-editor-' + this.questionId;
  }
  get editorConfig() {
    return {
      placeholder: this.$t('chapter.question.complementaryInfo.placeholder')
    };
  }
  onComplementaryInfoBlur(editorContent) {
    if (editorContent.trim() !== this.realtimeComplementaryInfo.trim()) {
      this.realtimeComplementaryInfo = editorContent.trim();
      axios.patch(`/api/v2/quiz-questions/${this.questionId}`, {
        questionDataJson: JSON.stringify({
          information: this.realtimeComplementaryInfo
        })
      }, {
        headers: {
          'Content-Type': 'application/json'
        }
      }).then(() => {
        WElmessage.showSuccessMessage(this.$t('chapter.question.complementaryInfo.updateSuccessful'));
      }, error => {
        AxiosUtils.displayError(error, this.$t('errors.default'));
      });
    }
  }
  onCloseBtnClick() {
    trig(Events.FIN_EDITION_QUIZZ_INFORMATION);
  }
};
__decorate([Prop({
  required: true
})], QuizQuestionComplementaryInfoEditor.prototype, "questionId", void 0);
__decorate([Prop({
  default: ''
})], QuizQuestionComplementaryInfoEditor.prototype, "complementaryInfo", void 0);
QuizQuestionComplementaryInfoEditor = __decorate([Component({
  components: {
    QuizHtmlEditor
  }
})], QuizQuestionComplementaryInfoEditor);
export default QuizQuestionComplementaryInfoEditor;